import { render, staticRenderFns } from "./TRPanelHeader.vue?vue&type=template&id=ad113086&"
import script from "./TRPanelHeader.vue?vue&type=script&lang=js&"
export * from "./TRPanelHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports